var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1843 2.98047C10.5242 2.97656 2.69995 10.7969 2.69995 20.4492C2.69995 28.082 7.59448 34.5703 14.4109 36.9531C15.3289 37.1836 15.1882 36.5312 15.1882 36.0859V33.0586C9.88745 33.6797 9.67261 30.1719 9.31714 29.5859C8.59839 28.3594 6.89917 28.0469 7.40698 27.4609C8.61401 26.8398 9.84448 27.6172 11.2703 29.7227C12.3015 31.25 14.3132 30.9922 15.3328 30.7383C15.5554 29.8203 16.032 29 16.6882 28.3633C11.196 27.3789 8.90698 24.0273 8.90698 20.043C8.90698 18.1094 9.5437 16.332 10.7937 14.8984C9.99683 12.5352 10.8679 10.5117 10.9851 10.2109C13.2546 10.0078 15.614 11.8359 15.7976 11.9805C17.0867 11.6328 18.5593 11.4492 20.2078 11.4492C21.864 11.4492 23.3406 11.6406 24.6414 11.9922C25.0828 11.6563 27.2703 10.0859 29.3796 10.2773C29.4929 10.5781 30.3445 12.5547 29.5945 14.8867C30.8601 16.3242 31.5046 18.1172 31.5046 20.0547C31.5046 24.0469 29.2 27.4023 23.6921 28.3711C24.1639 28.835 24.5385 29.3883 24.794 29.9987C25.0495 30.609 25.1809 31.2641 25.1804 31.9258V36.3203C25.2117 36.6719 25.1804 37.0195 25.7664 37.0195C32.6843 34.6875 37.6648 28.1523 37.6648 20.4531C37.6648 10.7969 29.8367 2.98047 20.1843 2.98047V2.98047Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.8788632f84ac21ce0e51f5cb4b2cd742.svg";
export { ForwardRef as ReactComponent };